import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Notification } from '../shared/models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
   
  constructor(
    private httpClient: HttpClient
  ) { }

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      `${error.error}`);
  }

  public list(): Observable<Notification[]> {
    return this.httpClient.get<Notification[]>('/api/notification/list').pipe(
      retry(0),
      catchError(this.handleError)
    );
  }

  public types(): Observable<string[]> {
    return this.httpClient.get<string[]>('/api/notification/types').pipe(
      retry(0),
      catchError(this.handleError)
    );
  }

  public create(notification: Notification): Observable<Object> {
    return this.httpClient.post('/api/notification', notification).pipe(
      retry(0),
      catchError(this.handleError)
    );
  }

  public update(notification: Notification): Observable<Object> {
    return this.httpClient.put('/api/notification', notification).pipe(
      retry(0),
      catchError(this.handleError)
    );
  }

  public delete(notification: Notification): Observable<Object> {
    const params = new HttpParams()
      .set('notificationId', notification.id);

    return this.httpClient.delete('/api/notification', { params }).pipe(
      retry(0),
      catchError(this.handleError)
    );
  }
}
